// Copyright (C) 2019 TANNER AG

import React, { useContext } from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { BusImage } from "../../components/busimage";
import { TranslationContext } from "../../translation";

const styles = {
	item: {
		flexBasis: 0,
		flexGrow: 1,
		width: "100%",
		maxWidth: "100%",
		"& > div": {
			display: "flex",
			alignItems: "center"
		},
		"&:first-child > div": {
			flexDirection: "row-reverse",
			paddingRight: 20
		},
		"&:nth-child(2) > div": {
			paddingLeft: 20
		}
	},
	image: {
		height: 50,
		"& > img": {
			width: "auto",
			height: "100%",
			boxShadow: "0 2px 4px 0 rgba(0,0,0,0.5)",
			borderRadius: 2
		}
	},
	name: {
		fontFamily: "MANEurope, Arial, sans-serif",
		fontWeight: "bold",
		fontStretch: "condensed",
		color: "#303C49",
		fontSize: 22,
		lineHeight: "30px",
		textAlign: "center"
	},
	description: {
		fontFamily: "MANEurope, Arial, sans-serif",
		fontWeight: 300,
		color: "#303C49",
		fontSize: 15,
		lineHeight: "22px",
		textAlign: "center"
	}
};

export const HeaderItem = withStyles(styles)((props) => {
	const { classes, name, doors, fuel, type } = props;
	const { translate } = useContext(TranslationContext);
	return (
		<div className={classes.item}>
			<div className={classes.itemInner}>
				<div style={{ width: "60%" }}>
					<div className={classes.name}>{name}</div>
					<div className={classes.description}>
						{`${doors} ${translate("common.doors")}`}, {fuel}
					</div>
				</div>
				<div className={classes.image}>
					<BusImage
						name={name}
						fuel={fuel}
						type={type}
					/>
				</div>
			</div>
		</div>
	);
});

HeaderItem.propTypes = {
	name: PropTypes.string,
	doors: PropTypes.number,
	fuel: PropTypes.string,
	type: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/tco/configuration/header/item.js